// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles__bannerIcon--cc91c {\n  background-color: #fff;\n}\n.styles__bannerIcon--cc91c > svg {\n    width: 40px;\n    height: 40px;\n  }\n", "",{"version":3,"sources":["webpack://./src/components/non-standart-learn-more/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AAMxB;AAJE;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".bannerIcon {\n  background-color: #fff;\n\n  & > svg {\n    width: 40px;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerIcon": "styles__bannerIcon--cc91c"
};
export default ___CSS_LOADER_EXPORT___;
